// import fetch from "auth/FetchInterceptor";

import { lossClient } from "api";

const FinanceAssetCodeService = {};

FinanceAssetCodeService.getFinanceAssetCodeList = function (userInput) {
  return lossClient({
    url: "/subproductfinanceasset/search?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default FinanceAssetCodeService;
